import { Box } from "../box"
import styles from "./divider.module.scss"

export function Divider({ className = "", gradient = false }: { className?: string; gradient?: boolean }) {
  return (
    <Box className={`w-full h-[1px] bg-white/50 ${gradient ? styles["divider__gradient"] : ""} ${className}`}></Box>
  )
}
